<template lang="html">
  <v-card>

    <v-card-title primary-title>
        <div class="headline text-xs-center w-100">Recover</div>
    </v-card-title>

    <v-card-text class="text-xs-left">
      <v-text-field label="Email"></v-text-field>
      <span class="primary--text pointer" @click="forgotAccount()">Go to login</span>
    </v-card-text>

    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn flat color="primary">Send email</v-btn>
    </v-card-actions>

  </v-card>
</template>

<script>
export default {
  methods: {
    forgotAccount: function () {
      this.$emit('toggle')
    }
  }
}
</script>

<style lang="css" scoped>
</style>
